import api from "src/api/index";
import {STATE_MEDIA} from "src/config";

export async function getPoints() {
  try {
    const response =  await api.get(STATE_MEDIA + "api/mobile/locations/points")
    return response
  } catch (error) {
    console.error("ошибка загрузки городов", error?.message)
  }
}